import React, {Component} from 'react';
import './styles.css';

class Alert extends Component {
  render() {
    if (!this.props.error && !this.props.success) {
      return null;
    }
    return (
      <div className="Alert">
        {this.props.error &&
          <div className="Alert-Box Alert-Box--error" role="alert">
            <i className="fa fa-exclamation-circle" aria-hidden="true" />
            <span>{this.props.error}</span>
          </div>}
        {this.props.success &&
          <div className="Alert-Box Alert-Box--success" role="status">
            <i className="fa fa-check-circle" aria-hidden="true" />
            <span>{this.props.success}</span>
          </div>}
      </div>
    );
  }
}

export default Alert;



// WEBPACK FOOTER //
// ./src/components/Alert/index.js